module.exports = __webpack_public_path__ + "static/media/3.f46eb668.svg";